export class ReportInformation {
  jurisdictionId: number;
  domicileId: number;
  countryName: string;
  isoCode: string;
  domicileStatus: number;
  filingDate: string;
  prepareByDate: string;
  reportDetailsCollapsed: boolean;
  dropdownCollapsed?: boolean;
}
